// extracted by mini-css-extract-plugin
export default {"root":"_3FEJx","positionStart":"_1jXWl","img":"T1e1A"};